import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import MediaQuery from 'react-responsive';
import FlatButton from 'material-ui/FlatButton';
import COLORS from '../../theme/colors';

import './app_bar_navigation.scss';

function AppBarNavigation(props) {
  const currentPath = props.currentPath;
  const goTo = props.history.push;

  const homePath = '/';
  const dashboardPath = '/dashboard';

  const getButtonStyle = (path) => {
    const isCurrentPath = currentPath === path;
    return {
      minWidth: 0,
      height: '30px',
      marginLeft: '10px',
      marginRight: '10px',
      color: COLORS.white,
      textTransform: 'uppercase',
      borderBottom: isCurrentPath ? '1px solid white' : 'none',
      fontWeight: isCurrentPath ? 'bold' : 'normal',
    };
  };

  return (
    <div className="app-bar-navigation">
      <MediaQuery minDeviceWidth={600} className="buttons-container">
        <FlatButton
          style={getButtonStyle(homePath)}
          onClick={() => goTo(homePath)}
        >
          Home
        </FlatButton>

        <FlatButton
          style={getButtonStyle(dashboardPath)}
          onClick={() => goTo(dashboardPath)}
        >
          Dashboard
        </FlatButton>
      </MediaQuery>

      <MediaQuery maxDeviceWidth={599} className="icons-container">
        <Link to="/" className="navigation-link">
          <div className="navigation-icon navigation-home" />
        </Link>
        <Link to="/dashboard" className="navigation-link">
          <div className="navigation-icon navigation-dashboard" />
        </Link>
      </MediaQuery>
    </div>
  );
}

AppBarNavigation.propTypes = {
  currentPath: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
};

export default withRouter(AppBarNavigation);



// WEBPACK FOOTER //
// ./src/components/app_bar_navigation/app_bar_navigation.jsx